/**
 * Upload Tools
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const userfilesQuery = gql`
  query GetUserFiles {
    images: getUserFiles {
      id
      fileUrl
      type
      size {
        width
        height
      }
      lowQuality: low_quality
    }
  }
`

export const deleteFileMutation = graphql(
  gql`
    mutation deleteImage($fileId: Int!) {
      deleteUserFile(fileId: $fileId) {
        message
      }
    }
  `,
  {
    name: 'deleteFile',
    withRef: true
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/UploadTab/data.ts